import errorLogger, {
  BUGSNAG_STATUSES,
} from '@picsart/growth-rc/services/errorLogger';

import { getContext } from '@/context';
import { getAppStore } from '@/store';
import { SIGNOUT_URL } from '@/consts/urls';
import { getTouchpoint } from '@/utils/environment/touchpointResolver';
import { PORTFOLIO_APP_TOUCH_POINT } from '@/utils/environment/surface';
import { clearAllGenerations } from '@/utils/storage/generationStorage';

export const logout = async (): Promise<void> => {
  const isPortfolioApp = getTouchpoint() === PORTFOLIO_APP_TOUCH_POINT;

  try {
    await clearAllGenerations();
    getAppStore().resetAll(); // Clear in-memory generation state

    if (isPortfolioApp) {
      const result = await getContext().handlers.publishEvent({
        event: 'logout',
      });
      if (result) {
        await getContext().handlers.refreshToken();
      }
    } else {
      await getContext().utils.api.fetch(SIGNOUT_URL, {
        method: 'POST',
        headers: { 'content-type': 'text/plain;charset=UTF-8' },
        body: '{}',
        credentials: 'include',
      });
    }
  } catch (error) {
    errorLogger.trigger(error as Error, BUGSNAG_STATUSES.WARN);
  }

  // The manual signout needs a reload to re-bootstrap auth as signed-out; the
  // genai-studio host drives its own post-logout flow.
  if (!isPortfolioApp) {
    window.location.reload();
  }
};

export const deleteAccount = async (): Promise<void> => {
  try {
    await getContext().handlers.publishEvent({ event: 'delete_account' });
  } catch (error) {
    errorLogger.trigger(error as Error, BUGSNAG_STATUSES.WARN);
  }
};
